import atypePieChart from './atypePie-chart'
import currentRemind from './current-remind'
export default {
  components: {
    atypePieChart,
    currentRemind
  },
  data() {
    return {}
  }
}
